import { MachinePublicHydrated } from "@aura-frontend/omnibus-az-client";
import { format, isToday } from "date-fns";

import { isPopulatedArray } from "@/pages/Tagging/utils/array";

const computeLedEntitlementDetails = (
  machine: Pick<
    MachinePublicHydrated,
    "smartAvailableActive" | "umpireAssistActive" | "smartBlockedActive"
  >,
) => {
  const hasStatTracking = isPopulatedArray(machine.smartAvailableActive);
  const hasUmpireAssist = isPopulatedArray(machine.umpireAssistActive);
  const hasBlocked = isPopulatedArray(machine.smartBlockedActive);

  const activeEntitlements = [
    ...(machine.smartAvailableActive || []),
    ...(machine.umpireAssistActive || []),
    ...(machine.smartBlockedActive || []),
  ];

  const lastActiveOccurrence = isPopulatedArray(activeEntitlements)
    ? activeEntitlements.sort((a, b) => (b.endTime ?? 0) - (a.endTime ?? 0))[0]
    : null;

  const endDate =
    lastActiveOccurrence?.endTime &&
    new Date(lastActiveOccurrence.endTime * 1000);

  const timeZoneAbbr =
    Intl.DateTimeFormat("en-US", {
      timeZoneName: "short",
    })
      .formatToParts(new Date())
      .find((part) => part.type === "timeZoneName")?.value || "";

  const endDateFormatted = endDate
    ? isToday(endDate)
      ? `${format(endDate, "h:mmaaa")} ${timeZoneAbbr}`.trim()
      : `${format(endDate, "M/d/yyyy h:mmaaa")} ${timeZoneAbbr}`.trim()
    : null;

  return {
    hasStatTracking,
    hasUmpireAssist,
    hasBlocked,
    endDateFormatted,
    lastActiveOccurrence,
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useLedEntitlementsDetails = (source?: any) => {
  if (!source || typeof source !== "object") {
    return null;
  }

  // UnifiedConfig shape: source.machine.smartAvailableActive
  if ("machine" in source && source.machine) {
    return computeLedEntitlementDetails(source.machine);
  }

  // MachinePublicHydrated / MachineRow shape: source.smartAvailableActive
  if ("smartAvailableActive" in source || "umpireAssistActive" in source) {
    return computeLedEntitlementDetails(source);
  }

  return null;
};
